import { render, staticRenderFns } from "./UpdateNotice.vue?vue&type=template&id=6014d420&scoped=true"
import script from "./UpdateNotice.vue?vue&type=script&lang=js"
export * from "./UpdateNotice.vue?vue&type=script&lang=js"
import style0 from "./UpdateNotice.vue?vue&type=style&index=0&id=6014d420&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6014d420",
  null
  
)

export default component.exports